var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#22BC5D",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5072 15.8929C12.1166 15.5024 11.4835 15.5024 11.0929 15.8929C10.7024 16.2834 10.7024 16.9166 11.0929 17.3071L12.5072 15.8929ZM14.2 19L13.4929 19.7071L14.2 20.4142L14.9072 19.7071L14.2 19ZM20.9072 13.7071C21.2977 13.3166 21.2977 12.6834 20.9072 12.2929C20.5166 11.9024 19.8835 11.9024 19.4929 12.2929L20.9072 13.7071ZM11.0929 17.3071L13.4929 19.7071L14.9072 18.2929L12.5072 15.8929L11.0929 17.3071ZM14.9072 19.7071L20.9072 13.7071L19.4929 12.2929L13.4929 18.2929L14.9072 19.7071Z",
    fill: "#22BC5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.c50ed930a70a8656fa8e07399547aa9d.svg";
export { ForwardRef as ReactComponent };